module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    class: 'ql-' + _vm.type
  }, _vm._l((_vm.pallete), function(color) {
    return _c('option', {
      domProps: {
        "value": color
      }
    })
  }), 0)
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-47c83db0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/TextEditor/toolbar/Color.vue
 ** module id = 815
 ** module chunks = 1
 **/